export var StorageKey;
(function (StorageKey) {
    StorageKey["OAUTH_REDIRECT_URL"] = "oauthRedirectUrl";
    StorageKey["PKCE_SECRET"] = "pkceSecret";
})(StorageKey || (StorageKey = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdGFudHMvc3RvcmFnZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQU4sSUFBWSxVQUdYO0FBSEQsV0FBWSxVQUFVO0lBQ3BCLHFEQUF1QyxDQUFBO0lBQ3ZDLHdDQUEwQixDQUFBO0FBQzVCLENBQUMsRUFIVyxVQUFVLEtBQVYsVUFBVSxRQUdyQiJ9